/**
      *********************************************************
      Description: Right sidebar.
      Required props:  options,items. Items to generate icons and names.
      limitations    : N/A
      *********************************************************
**/
import { Box, Paper, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
//import MenuItem from '@material-ui/core/MenuItem';
//Expansion Panels For Tree
import { deepPurple } from '@material-ui/core/colors';
// Menu Items and Grouping
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter } from "react-router-dom";
//import useUnsavedChangesWarning from '../form/useUnsavedChangesWarning';
import { makeStyles } from '@material-ui/core/styles';
import { AddCircleOutline } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    listItem: {
        '&:hover': {
            backgroundColor: '#ede7f6',
            color: '#5e35b1',
            //backgroundColor: 'rgb(215 225 229)',
            // backdropFilter: 'blur(10px)',
            // border: '1px solid #00355f',
            // boxShadow: '0 1px 0px 0 #00355f, 0 0px 0px 0 #00355f',
            // borderRadius: '10px',
            // border: '2px solid #00355f',
            // borderRadius: '10px',  // Change the color and thickness as needed
        },
    },
    selected: {
        backgroundColor: '#ede7f6',
        color: '#5e35b1',
        //backgroundColor: 'rgb(215 225 229)',
        //     backdropFilter: 'blur(10px)',
        //     border: '1px solid #00355f',
        //   //  boxShadow: '0 0px 0px 0 #00355f, 0 0px 0px 0 #00355f',
        //     borderRadius: '10px',

    },
    hiddenIcon: {
        display: 'none',
    },
    parent: {
        '&:hover $hiddenIcon': {
            display: 'block',
        },
    },
    textWithSpace: {
        marginRight: '40px',
    },
}));

const drawerWidth = 250;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth - 50,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    purpleAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: deepPurple[500],
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(9.2) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px 0 0',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1) * 3,
    },
    last: {
        display: 'flex',
        position: 'fixed',
        bottom: '0px',
        backgroundColor: '#212529 !important',
        margin: '0px'
    },

});





const SidebarView = withStyles(styles)((props) => {
    const { options, components, defaults, order, type, children, rules, drawerOpen, handleTitle, classes, theme, width, ...otherProps } = props;
    const { text, icon, items, anchor, ...otherOptions } = options
    let Profile = localStorage.getItem('profile') && JSON.parse(localStorage.getItem('profile'))
    const open = useSelector(state => state.header && state.header.leftmenuDrawer ? state.header.leftmenuDrawer : false);
    const isTabView = useSelector(state => state.header && state.header.movebartoTop ? state.header.movebartoTop : 'N')



    if (Profile && open && isTabView === 'N')
        return (
            <>
                <Drawer open={true}
                    variant="permanent"
                    anchor={anchor}
                    className={classNames(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: classNames({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                    {...otherOptions}
                >
                    <Toolbar />
                    <Wrapper items={items} classes={classes} Profile={Profile} />
                </Drawer>
            </>
        );
    else return <div></div>
});



// const Popovers = (props) => {

//     const [anchorEl, setAnchorEl] = React.useState(null);

//     const handleClick = event => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//     };

//     const open = Boolean(anchorEl);
//     const id = open ? 'simple-popover' : undefined;

//     let submodules = JSON.parse(localStorage.getItem('submodule')) || []


//     const CSSColorClasses = (style = '') => {
//         let module = getEnvVariable('ModuleKey')
//         switch (module) {
//             case 'AEPS':
//                 return 'rgba(0, 53, 95, 255)'
//             // case 'AMES':
//             //     return 'rgb(41,51,82) !important'
//             case 'WRS':
//                 return '#0076A5'
//             default:
//                 return '';
//         }
//     }

//     return (
//         <div>
//             {/* {props && props.moduleRegionAccess.find(element => element === 'Add') && <IconButton onClick={handleClick} title="Quick Links"><AddIcon /></IconButton>} */}
//             <IconButton onClick={handleClick} title="Quick Links" style={{ color: CSSColorClasses() }}><AddIcon /></IconButton>
//             <Popover
//                 id={id}
//                 open={open}
//                 anchorEl={anchorEl}
//                 onClose={handleClose}
//                 anchorOrigin={{
//                     vertical: 'bottom',
//                     horizontal: 'center',
//                 }}
//                 transformOrigin={{
//                     vertical: 'top',
//                     horizontal: 'center',
//                 }}
//             >
//                 {submodules && Array.isArray(submodules) && submodules.length > 0 && submodules.map(res => {
//                     if (getEnvVariable('AccessPortal') === 'E' && res.key && (hideForSubmodules(res.key))) {
//                         return null
//                     }
//                     else {
//                         return <Typography paragraph gutterBottom={true} className="m-3 " onClick={handleClose}>
//                             <Link to={`${res.link}/NEW`}> {`Apply for ${res.title}`}</Link>
//                         </Typography>
//                     }
//                 })}
//                 <Divider />
//             </Popover>
//         </div>
//     );
// }
/**
      *********************************************************
      Description: Wrapper for generating the menu or grouping items or having the tree layout.
      Required props:  items
      limitations    : N/A
      *********************************************************
**/
const Wrapper = (props) => {
    const { items, classes, Profile, canAdd = false } = props
    // setPristine();
    return items && items.length > 0 && items.map(each => {
        const { type, key, ...otherProps } = each
        if (type === 'menu')
            return <MenuItem {...otherProps} key={key} Profile={Profile} canAdd={canAdd} />
        if (type === 'group')
            return <GroupItem {...otherProps} classes={classes} key={key} />
        if (type === 'tree')
            return <TreeItem {...otherProps} classes={classes} key={key} />
        if (type === 'recordmenu')
            return <RecordMenuView {...otherProps} classes={classes} key={key} />
    })
}

/**
      *********************************************************
      Description: Generates list item.
      Required props:  N/A
      limitations    : N/A
      *********************************************************
**/
const handleNewClick = (event, link, history) => {
    event.stopPropagation(event);
    history.push(link + '/new')
}



export const MenuItem = withRouter(({ location, history, canAdd, ...listitem }) => {
    const classes = useStyles();
    const { link, handleTitle, reloadtab, newtab, isProfile, Profile } = listitem;
    //   const [Prompt, setDirty, setPristine] = useUnsavedChangesWarning();
    let tempColor = {
        "style": {
            'color': listitem.color || ''
        }
    }

    const handleTabClick = () => {
        if (newtab) {
            window.open(link, '_blank');
        }
        // else if (reloadtab) {
        //     window.open('#' + link, '_self');
        //     window.location.reload();
        // }

        else {
            history.push(link)
        }
    }
    // React.useEffect(() => {
    //     let linkisval = isProfile ? link + (Profile && Profile.modulePermissions && Profile.modulePermissions[0] && Profile.modulePermissions[0].companyId) : link;
    //     if (linkisval === location.pathname) {
    //         //    setPristine();
    //     }
    // }, [location.pathname])

    if (link) {
        const linkis = isProfile ? link + (Profile && Profile.modulePermissions && Profile.modulePermissions[0] && Profile.modulePermissions[0].companyId) : link;
        return (
            <Fragment  >
                <Link to={linkis} className={classes.parent} target={newtab ? "_blank" : ""} >
                    <ListItem button onClick={() => handleTabClick()}
                        className={linkis === location.pathname ? classes.selected : classes.listItem}  >
                        <ListItemIcon ><Icon style={listitem.style || tempColor.style}>{listitem.materialicon}</Icon></ListItemIcon>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <ListItemText primary={listitem.title} />
                            <div style={{ marginRight: '10px' }} />
                        </div>
                        {canAdd && <Link onClick={(event) => handleNewClick(event, listitem.link, history)} >
                            <ListItemIcon className={classes.hiddenIcon}><AddCircleOutline /></ListItemIcon></Link>}
                    </ListItem>
                </Link>
                {/* { //selected={linkis === location.pathname}
                    newtab && <Link href={linkis} target={newtab ? "_blank" : ""} rel="noopener noreferrer" placement="top-start" className={classes.parent}>
                        <ListItem button style={{ m: 0, p: 0 }}
                            className={linkis === location.pathname ? classes.selected : classes.listItem} >
                            {<ListItemIcon><Icon style={listitem.style || tempColor.style} >{listitem.materialicon} </Icon></ListItemIcon>}
                            <ListItemText style={{ color: 'black' }}
                                key={listitem.materialicon}><Typography variant="body2">{listitem.title}</Typography></ListItemText>
                            {
                                canAdd && <Link onClick={(event) => handleNewClick(event, listitem)}
                                >   <ListItemIcon className={classes.hiddenIcon}><AddCircleOutline /></ListItemIcon></Link>
                            }
                        </ListItem>
                    </Link>

                } */}
            </Fragment >
        )

    }//selected
    else {
        return (
            <ListItem>
                <ListItemText key={listitem.title}><Typography variant="body2">{listitem.title}</Typography></ListItemText>
            </ListItem>
        )
    }
})
/**
      *********************************************************
      Description: Generates items.
      Required props:  N/A
      limitations    : N/A
      *********************************************************
**/
const GroupItem = (groupitems) => {
    return (
        <Fragment>
            <Divider />
            <List>
                <Wrapper {...groupitems.items} />
            </List>
            <Divider />
        </Fragment>
    )
}
/**
      *********************************************************
      Description: Generates items in the form of a tree with a expand collapse icon.
      Required props:  N/A
      limitations    : N/A
      *********************************************************
**/


const TreeItem = (treeitems) => {
    const { title, items, materialicon, lskey } = treeitems;
    console.log("title", treeitems)
    return (
        <Box style={{ marginTop: 10, marginLeft: 1 }}>
            <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 'bolder' }}>
                {title}
            </Typography>
            <Wrapper items={lskey ? JSON.parse(localStorage.getItem(lskey)) : items} />
            < Divider />
        </Box>
    )
}

const RecordMenuView = (treeitems) => {
    const { title, items, materialicon, lskey } = treeitems;
    return (
        <Wrapper items={lskey ? JSON.parse(localStorage.getItem(lskey)) : items} canAdd={true} />
    )
}

SidebarView.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withWidth()(withRouter(SidebarView));

